module.exports = require("./fr-WF.d.ts");